<template>
  <div class="phase-container" style="display: flex; justify-content: center">
    <!-- Phase 1 -->
    <svg
      @click="onClickPhase(1)"
      :style="{ cursor: phase1Color === '#00925E' ? 'pointer' : 'default' }"
      width="95.4"
      height="53.1"
      viewBox="0 0 106 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.5 0C43.2909 0 41.5 1.79086 41.5 4V19C41.5 21.2091 43.2909 23 45.5 23H50.1132L53 28L55.8868 23H60.5C62.7091 23 64.5 21.2091 64.5 19V4C64.5 1.79086 62.7091 0 60.5 0H45.5Z"
        :fill="phase1Color"
      />
      <path
        d="M51.8978 10.392L50.3218 11.16V8.248L53.6258 6.44H54.9938V17H51.8978V10.392Z"
        :fill="phase1NumberColor"
      />
      <text
        x="53"
        y="54"
        text-anchor="middle"
        font-family="Inter, sans-serif"
        font-size="14"
        font-weight="600"
        :fill="phase1TextColor"
      >
        Ideate!
      </text>
    </svg>
    <!-- Phase 2 -->
    <svg
      @click="onClickPhase(2)"
      :style="{ cursor: phase2Color === '#00925E' ? 'pointer' : 'default' }"
      width="95.4"
      height="53.1"
      viewBox="0 0 106 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.5 0C43.2909 0 41.5 1.79086 41.5 4V19C41.5 21.2091 43.2909 23 45.5 23H50.1132L53 28L55.8868 23H60.5C62.7091 23 64.5 21.2091 64.5 19V4C64.5 1.79086 62.7091 0 60.5 0H45.5Z"
        :fill="phase2Color"
      />
      <path
        d="M52.8967 8.848C52.6034 8.848 52.342 8.928 52.1127 9.088C51.8887 9.248 51.6967 9.43733 51.5367 9.656C51.382 9.86933 51.262 10.0667 51.1767 10.248C51.0914 10.424 51.0434 10.528 51.0327 10.56L48.4087 9.344C48.4194 9.264 48.47 9.10933 48.5607 8.88C48.6514 8.64533 48.798 8.38133 49.0007 8.088C49.2034 7.78933 49.4727 7.50133 49.8087 7.224C50.15 6.94133 50.574 6.70933 51.0807 6.528C51.5874 6.34133 52.1927 6.248 52.8967 6.248C53.7607 6.248 54.4647 6.37333 55.0087 6.624C55.5527 6.87467 55.9714 7.192 56.2647 7.576C56.5634 7.95467 56.7687 8.34667 56.8807 8.752C56.998 9.15733 57.0567 9.512 57.0567 9.816C57.0567 10.28 56.974 10.7147 56.8087 11.12C56.6434 11.52 56.43 11.888 56.1687 12.224C55.9074 12.5547 55.6274 12.8507 55.3287 13.112C55.0354 13.368 54.7554 13.5867 54.4887 13.768C54.222 13.9493 54.0007 14.088 53.8247 14.184C53.6487 14.2747 53.5527 14.3227 53.5367 14.328H56.9687V17H48.9207V14.568C48.942 14.5573 49.0754 14.472 49.3207 14.312C49.5714 14.152 49.886 13.9413 50.2647 13.68C50.6487 13.4133 51.0514 13.1147 51.4727 12.784C51.8994 12.4533 52.2994 12.1093 52.6727 11.752C53.0514 11.3947 53.358 11.0453 53.5927 10.704C53.8327 10.3627 53.9527 10.0507 53.9527 9.768C53.9527 9.43733 53.8594 9.20267 53.6727 9.064C53.4914 8.92 53.2327 8.848 52.8967 8.848Z"
        :fill="phase2NumberColor"
      />
      <text
        x="53"
        y="54"
        text-anchor="middle"
        font-family="Inter, sans-serif"
        font-size="14"
        font-weight="600"
        :fill="phase2TextColor"
      >
        Pick
      </text>
    </svg>
    <!-- Phase 3 -->
    <svg
      @click="onClickPhase(3)"
      :style="{ cursor: phase3Color === '#00925E' ? 'pointer' : 'default' }"
      width="95.4"
      height="53.1"
      viewBox="0 0 106 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M45.5 0C43.2909 0 41.5 1.79086 41.5 4V19C41.5 21.2091 43.2909 23 45.5 23H50.1132L53 28L55.8868 23H60.5C62.7091 23 64.5 21.2091 64.5 19V4C64.5 1.79086 62.7091 0 60.5 0H45.5Z"
        :fill="phase3Color"
      />
      <path
        d="M49.4859 8.848C49.5553 8.57067 49.6859 8.28 49.8779 7.976C50.0753 7.672 50.3339 7.38933 50.6539 7.128C50.9793 6.86667 51.3686 6.656 51.8219 6.496C52.2806 6.33067 52.8059 6.248 53.3979 6.248C54.0646 6.248 54.6726 6.37067 55.2219 6.616C55.7766 6.86133 56.2166 7.21333 56.5419 7.672C56.8726 8.12533 57.0379 8.66933 57.0379 9.304C57.0379 9.624 56.9846 9.92 56.8779 10.192C56.7713 10.464 56.6353 10.6933 56.4699 10.88C56.3046 11.0667 56.1313 11.192 55.9499 11.256C56.1793 11.2987 56.4113 11.424 56.6459 11.632C56.8859 11.8347 57.0859 12.104 57.2459 12.44C57.4113 12.776 57.4939 13.1653 57.4939 13.608C57.4939 14.312 57.3126 14.9333 56.9499 15.472C56.5873 16.0107 56.0939 16.432 55.4699 16.736C54.8513 17.04 54.1473 17.192 53.3579 17.192C52.5046 17.192 51.7819 17.04 51.1899 16.736C50.6033 16.432 50.1393 16.0587 49.7979 15.616C49.4566 15.1733 49.2326 14.7467 49.1259 14.336L51.9659 12.952C52.0193 13.176 52.1073 13.4133 52.2299 13.664C52.3526 13.9093 52.5073 14.1173 52.6939 14.288C52.8859 14.4587 53.1046 14.544 53.3499 14.544C53.5739 14.544 53.7659 14.5013 53.9259 14.416C54.0913 14.3307 54.2193 14.2107 54.3099 14.056C54.4006 13.9013 54.4459 13.7173 54.4459 13.504C54.4459 13.296 54.3979 13.12 54.3019 12.976C54.2059 12.832 54.0753 12.7253 53.9099 12.656C53.7446 12.5813 53.5579 12.544 53.3499 12.544H53.1419V10.384H53.4139C53.5899 10.384 53.7419 10.3493 53.8699 10.28C54.0033 10.2107 54.1046 10.112 54.1739 9.984C54.2486 9.856 54.2859 9.70667 54.2859 9.536C54.2859 9.30133 54.2033 9.104 54.0379 8.944C53.8779 8.77867 53.6566 8.696 53.3739 8.696C53.1713 8.696 52.9873 8.73867 52.8219 8.824C52.6619 8.904 52.5206 9.01067 52.3979 9.144C52.2806 9.27733 52.1846 9.42133 52.1099 9.576C52.0353 9.73067 51.9819 9.88 51.9499 10.024L49.4859 8.848Z"
        :fill="phase3NumberColor"
      />
      <text
        x="53"
        y="54"
        text-anchor="middle"
        font-family="Inter, sans-serif"
        font-size="14"
        font-weight="600"
        :fill="phase3TextColor"
      >
        Build!
      </text>
    </svg>
  </div>
</template>

<script setup>
import { ref, computed, watch, defineEmits, defineProps, onMounted } from "vue";

const props = defineProps({
  selectedNumber: {
    type: [Number],
    default: 1,
  },
});

const ACTIVE_COLOR = "#00925E";
const INACTIVE_COLOR = "#98A2B3";

const phase1Color = ref(INACTIVE_COLOR);
const phase2Color = ref(INACTIVE_COLOR);
const phase3Color = ref(INACTIVE_COLOR);

const textColorFor = (bubbleColor) =>
  bubbleColor === ACTIVE_COLOR ? ACTIVE_COLOR : "#3B4648";

const numberColorFor = (bubbleColor) =>
  bubbleColor === ACTIVE_COLOR ? "white" : "#3B4648";

const phase1TextColor = computed(() => textColorFor(phase1Color.value));
const phase2TextColor = computed(() => textColorFor(phase2Color.value));
const phase3TextColor = computed(() => textColorFor(phase3Color.value));

const phase1NumberColor = computed(() => numberColorFor(phase1Color.value));
const phase2NumberColor = computed(() => numberColorFor(phase2Color.value));
const phase3NumberColor = computed(() => numberColorFor(phase3Color.value));

function updateColors(newValue) {
  switch (newValue) {
    case 1:
      phase1Color.value = ACTIVE_COLOR;
      phase2Color.value = INACTIVE_COLOR;
      phase3Color.value = INACTIVE_COLOR;
      break;
    case 2:
      phase1Color.value = ACTIVE_COLOR;
      phase2Color.value = ACTIVE_COLOR;
      phase3Color.value = INACTIVE_COLOR;
      break;
    case 3:
      phase1Color.value = ACTIVE_COLOR;
      phase2Color.value = ACTIVE_COLOR;
      phase3Color.value = ACTIVE_COLOR;
      break;
  }
}

watch(() => props.selectedNumber, updateColors);

const emit = defineEmits(["phase-clicked"]);

const onClickPhase = (phaseNumber) => {
  emit("phase-clicked", phaseNumber);
};

onMounted(() => {
  updateColors(props.selectedNumber);
});
</script>

<style scoped>
.phase-container {
  background-color: #f2f3fb;
  max-width: 400px;
  margin: 0px auto;
  padding: 20px 0px;
  border-radius: 16px;
  border: 1px solid #d8dae5;
}
</style>
